import { useTranslation } from 'react-i18next';
import { PageShell } from '@/components/layout';
import { Container, Link, Typography } from '@/components/ui';

export default function NotFound() {
  const { t } = useTranslation();
  return (
    <PageShell
      title={t('notFound.meta.title')}
      description={t('notFound.meta.description')}
      path="/404"
    >
      <Container>
        <section className="py-30 text-center">
          <Typography variant="eyebrow">{t('notFound.eyebrow')}</Typography>
          <Typography variant="display-lg" as="h1" className="mt-4">
            {t('notFound.heading')}
          </Typography>
          <Typography variant="body-lg" tone="muted" className="mt-6">
            {t('notFound.description')}
          </Typography>
          <Link to="/" className="mt-8 inline-block">
            {t('notFound.backToHome')}
          </Link>
        </section>
      </Container>
    </PageShell>
  );
}
